export default "__VITE_ASSET__68ce3740__"